import { Controller, FieldValues } from 'react-hook-form';

import { EmailField } from '../lib/EmailField';

import { ControlledEmailFieldProps } from './types';

export const ControlledEmailField = <T extends FieldValues>({
  name,
  control,
  ...otherProps
}: ControlledEmailFieldProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restField } = field;
        return (
          <EmailField
            {...restField}
            {...otherProps}
            error={!!error}
            ref={ref}
            helperText={error?.message}
          />
        );
      }}
    />
  );
};
